<template>
  <div class="navbar-item d-flex" @click="setModal()">
    <a
        :href="returnLink()"
        :class="home ? 'home-link call-to-actionheader-home nav-link' : 'call-to-actionheader nav-link link-color'"
    >
      <i class="fa fa-user"></i>
      {{ this.returnName }}
    </a>
  </div>
</template>

<script>
export default {
  props: ['home'],
  methods: {
    setModal() {
      if(this.$root.user.id === null) {
        this.$root.isModalShow = !this.$root.isModalShow
      }

      if(this.$root.isModalShow) {
        this.$root.showLogin();
      } else {
        this.$root.closeLogin();
      }
    },
    trimString(string) {
        if(string.length > 10){
            return string.substring(0,11) + '...';
        }
        
        return string;
    },
    returnLink() {
      if(!this.$root.user.id) {
        return '#';
      }

      return '/areariservata';
    }
  },
  computed: {
    returnName() {
      if(this.$root.user.id) {
        return this.trimString(this.$root.user.nome + ' ' + ( this.$root.user.cognome ? this.$root.user.cognome : '' )) ;
      }
      return ' Accedi';
    }
  },
  data() {
    return {
    }
  }
}
</script>

<style>

</style>
